import React, {useMemo,useCallback} from 'react';
import {useDropzone} from 'react-dropzone';
import {Button} from "../buttons";


const Dropzone = (props) => {
    const onDrop = useCallback(file => {
        props.onFileDrop(file)
    }, []);

    const {
        acceptedFiles,
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({onDrop});

    const style = useMemo(() => ({
        ...baseStyle,
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isDragActive,
        isDragReject,
        isDragAccept
    ]);

    return (
        <section className="container">
            <div {...getRootProps({style, className: 'dropzone'})}>
                <input {...getInputProps()} />
                <p className="text-primary">
                    <b>Taruh file .XLS atau .XLSX di sini</b>
                </p>
                <p>
                    Atau
                </p>
                <Button
                    className="btn btn-primary border-0"
                >
                    Pilih File
                </Button>
            </div>
        </section>
    );
}

export default Dropzone;

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '64px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const activeStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};
